import Model from '../Model'

export default class OrderItem extends Model {
  primaryKey () {
    return 'id'
  }
}
